export default {
  text: {
    en: 'Price reduced from:',
  },
}
